import React from "react";

function Slider({ name, min, max, value, onChange }) {
    return (
        <div className="slider-container">
            <h3>
                {name}: {value}
            </h3>
            <input
                type="range"
                min={min}
                max={max}
                value={value}
                className="slider"
                onChange={onChange}
                step="1"
            />
        </div>
    );
}

export default Slider;
